var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35842 6.47406C7.11434 6.22998 6.71862 6.22998 6.47454 6.47406C6.23046 6.71814 6.23046 7.11387 6.47454 7.35794L8.11594 8.99935L6.47456 10.6407C6.23048 10.8848 6.23048 11.2805 6.47456 11.5246C6.71863 11.7687 7.11436 11.7687 7.35844 11.5246L8.99982 9.88323L10.6412 11.5246C10.8853 11.7687 11.281 11.7687 11.5251 11.5246C11.7691 11.2805 11.7691 10.8848 11.5251 10.6407L9.8837 8.99935L11.5251 7.35796C11.7692 7.11388 11.7692 6.71816 11.5251 6.47408C11.281 6.23 10.8853 6.23 10.6412 6.47408L8.99982 8.11546L7.35842 6.47406Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 0.0410156C4.05229 0.0410156 0.0415039 4.0518 0.0415039 8.99935C0.0415039 13.9469 4.05229 17.9577 8.99984 17.9577C13.9474 17.9577 17.9582 13.9469 17.9582 8.99935C17.9582 4.0518 13.9474 0.0410156 8.99984 0.0410156ZM1.2915 8.99935C1.2915 4.74215 4.74264 1.29102 8.99984 1.29102C13.257 1.29102 16.7082 4.74215 16.7082 8.99935C16.7082 13.2565 13.257 16.7077 8.99984 16.7077C4.74264 16.7077 1.2915 13.2565 1.2915 8.99935Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutline);
export default __webpack_public_path__ + "static/media/close-outline.a31aafa8e6057c3561daea10a8c067e3.svg";
export { ForwardRef as ReactComponent };